module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAOCAYAAADqtqZhAAAAFklEQVQImWN8nSLwnwEKmBiQwGDmAACzrgJ6QpWtGgAAAABJRU5ErkJggg=="